import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"
import { useContext } from "react"
//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeLogin,
  postJwtLogin,
  postJwtLogout
} from "../../../helpers/fakebackend_helper"

import jwt from "jsonwebtoken";
import { AuthContext } from "../authContext"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  
  try {
    
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      )
      yield put(loginSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        "UserName": user.username,
        "Password": user.password,
      })
      if(response.status){
        if(response.token)
          {
            const cleanToken = response.token.replace(/^"+|"+$/g, '');
            const decodedToken = jwt.decode(cleanToken);
            
            // sessionStorage.setItem("authUser", JSON.stringify(cleanToken));

            if (decodedToken && decodedToken.userRolePermissions) {
              const UserRolePermissions = JSON.parse(decodedToken.userRolePermissions);
              //sessionStorage.setItem("UserRolePermissions", JSON.stringify(UserRolePermissions));
              sessionStorage.setItem("userFullName", decodedToken.userFullName);
            } else {
              console.error("Invalid token or missing userRolePermissions");
            }
          }
       
        yield put(loginSuccess(response))
        yield put(apiError(null))
      }
      else{
        yield put(apiError(response.message))
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      })
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogout, {
        "Token": sessionStorage.getItem("Clear_AuthUser"),
      })
      if(response.status){
        yield put(logoutUserSuccess(response))
        yield put(apiError(null))
      }
      else{
        yield put(apiError(response.message))
      }
    }

    // sessionStorage.removeItem("authUser")
    sessionStorage.removeItem("userFullName")

    sessionStorage.removeItem("Clear_AuthUser")

    sessionStorage.removeItem("GetToChange")

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

const Authlogin = (UserRolePermissions, userFullName) =>
{
 
  try{
    const { setUserPermissions, setUserFullName } = useContext(AuthContext);
    setUserPermissions(UserRolePermissions);
    setUserFullName(userFullName);
  }
  catch(error)
  {
    debugger;
  }

};

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
